module.exports = __webpack_public_path__ + "img/flower_leaf_20.3518549c.png";